import React from 'react';
import { AdminQuotesList } from '../../components/admin/QuotesList';
import { useAdminQuotes } from '../../hooks/useAdminQuotes';

export const QuotesListPage: React.FC = () => {
  const quotesListProps = useAdminQuotes();

  return <AdminQuotesList {...quotesListProps} />;
};
